import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtMoney } from "@/lib/api";
import { Tag } from "@/components/common";

const BOOKED = ["Booked", "Attended"];

// Booked value (pre-filled S$280) + "Package closed" step for a Booked lead.
export const LeadValue = ({ lead, presets, onSaved }) => {
  const [value, setValue] = useState(lead.booking_value ?? "");
  const [custom, setCustom] = useState("");
  if (!BOOKED.includes(lead.status)) return <span className="text-slate-600">—</span>;
  const save = async (patch, ok) => {
    try { await api.put(`/leads/${lead.id}`, patch); toast.success(ok); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  const up = lead.package_uploads?.at(-1);
  return (
    <div className="space-y-1.5 text-xs" data-testid={`lead-value-${lead.id}`}>
      <label className="flex items-center gap-1 text-slate-400">Booked S$
        <input data-testid={`lead-booking-value-${lead.id}`} type="number" min="0" className="cc-input w-20 px-1 py-0.5 text-xs" value={value}
          onChange={(e) => setValue(e.target.value)} onBlur={() => value !== "" && Number(value) !== lead.booking_value && save({ booking_value: Number(value) }, "Booked value saved")} /></label>
      {lead.package_value ? <div data-testid={`lead-package-${lead.id}`}><Tag tone="emerald">Package {fmtMoney(lead.package_value)}</Tag>{up && <div className="mt-0.5 text-[10px] text-slate-500">{up.status}: {up.message || "sent to Google Ads"}</div>}</div> : (
        <div className="flex flex-wrap items-center gap-1">
          <span className="text-slate-500">Package closed:</span>
          {presets.map((p) => <button key={p} data-testid={`lead-package-${p}-${lead.id}`} onClick={() => save({ package_value: p }, `Package ${fmtMoney(p)} recorded`)} className="cc-btn cc-btn-ghost px-1.5 py-0.5 text-[11px]">{fmtMoney(p)}</button>)}
          <input data-testid={`lead-package-custom-${lead.id}`} type="number" min="0" placeholder="Custom" className="cc-input w-20 px-1 py-0.5 text-xs" value={custom} onChange={(e) => setCustom(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && custom && save({ package_value: Number(custom) }, `Package ${fmtMoney(Number(custom))} recorded`)} />
        </div>)}
    </div>
  );
};
